<template>
  <div
    class="rounded shadow-sm min-h-32 border p-4 mb-4 knowledge-list"
    @click="redirectToArticle"
  >
    <div class="knowledge-list-heading">{{ article.title }}</div>
    <div :inner-html.prop="article.text | truncate" class="knowledge-list-content"></div>
  </div>
</template>

<script>
export default {
    name: "Article",
    props: ["article"],
    methods: {
        redirectToArticle() {
            this.$router.push({
                name: "KnowledgeArticle",
                params: {
                    slug: this.article.slug
                }
            });
        }
    }
};
</script>

<style >
.truncate {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.knowledge-list {
  background: var(--knowledge-list-background);
}
.knowledge-list-heading {
  color: var(--knowledge-list-heading-color);
  font-size: var(--knowledge-list-heading-font-size);
  font-weight: var(--knowledge-list-heading-font-weight);
  line-height: var(--knowledge-list-heading-line-height);
}

.knowledge-list-content {
  color: var(--knowledge-list-content-color);
  font-size: var(--knowledge-list-content-font-size);
  font-weight: var(--knowledge-list-content-font-weight);
  line-height: var(--knowledge-list-content-line-height);
}
</style>
